var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5C9.77817 12.5 11.625 10.6532 11.625 8.375C11.625 6.09683 9.77817 4.25 7.5 4.25C5.22183 4.25 3.375 6.09683 3.375 8.375C3.375 10.6532 5.22183 12.5 7.5 12.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 20.75C0.75 18.9598 1.46116 17.2429 2.72703 15.977C3.9929 14.7112 5.70979 14 7.5 14C9.29021 14 11.0071 14.7112 12.273 15.977C13.5388 17.2429 14.25 18.9598 14.25 20.75",
    "troke-width": 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.251 4.91605C14.8739 4.51133 15.5944 4.28232 16.3367 4.25318C17.0789 4.22404 17.8152 4.39585 18.4679 4.75049C19.1206 5.10512 19.6654 5.62941 20.0448 6.268C20.4242 6.90659 20.6241 7.63578 20.6235 8.37858C20.6229 9.12138 20.4216 9.85022 20.0411 10.4882C19.6606 11.1261 19.1149 11.6494 18.4616 12.0029C17.8083 12.3564 17.0717 12.527 16.3295 12.4965C15.5873 12.4661 14.8672 12.2358 14.245 11.83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.167C15.9886 13.943 17.0148 13.9444 18.0028 14.1708C18.9908 14.3973 19.9151 14.8432 20.7074 15.4754C21.4997 16.1076 22.1396 16.9099 22.5798 17.823C23.0199 18.736 23.249 19.7364 23.25 20.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.d44bdb2756212413c62fd4766215a4ba.svg";
export { ForwardRef as ReactComponent };